import { CreateNewReducer } from "../utils/reducerUtils";

const INITIAL_STATE = [];
const uferdistilteKlagesakerReducer = (state = [...INITIAL_STATE], action) =>
  CreateNewReducer(state, action, "UFERDIGSTILTE_KLAGESAKER");

export default uferdistilteKlagesakerReducer;
